import { Component, EventEmitter, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, Validators } from '@angular/forms';
import { ExternalReference, ExternalReferenceType_ENUM } from '@models/mood/dataset-metainfo';
import { EXTERNAL_REFERENCE_TYPE_PLATFORMS } from 'src/app/constant';


export interface ExternalReferenceForm {
  platform: FormControl<ExternalReferenceType_ENUM | null>;
  identifier: FormControl<string | null>;
  label: FormControl<string | null>;
}


@Component({
  selector: 'mood-dataset-admin-reference-form',
  templateUrl: './reference-form.component.html',
  styleUrls: [
    'reference-form.component.scss'
  ]
})
export class ExternalReferenceFormComponent {
  @Output() removeReferenceEntryTriggered = new EventEmitter();

  constructor(private _controlContainer: ControlContainer) { }

  possible_platforms = EXTERNAL_REFERENCE_TYPE_PLATFORMS;

  get formGroupContainer() {
    return this._controlContainer.control as FormGroup;
  }

  get hasPlatformSet() {
    return this.formGroupContainer.get('platform')?.value;
  }

  removeReferenceEntry() {
    this.removeReferenceEntryTriggered.emit();
  }

  public static createExternalReferenceFormGroup(existingExternalReference?: ExternalReference) {
    const formGroup = new FormGroup<ExternalReferenceForm>({
      platform: new FormControl<ExternalReferenceType_ENUM | null>(existingExternalReference?.platform || null, [Validators.required]),
      identifier: new FormControl<string | null>(existingExternalReference?.identifier || null, [Validators.required]),
      label: new FormControl<string | null>(existingExternalReference?.label || null)
    });

    return formGroup;
  }
}
